import {
	SelectControl,
	BaseControl,
	Dashicon,
	Button,
	__experimentalElevation as Elevation,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import './style.scss';
import fontOptions from '../../options/font-family';
import loadGoogleFont from '../../options/load-goggle-font';


const MyTypographyControl = ({ label, typography, onChange }) => {
	const { fontFamily } = typography;
	const [showTypography, setShowTypography] = useState(false);	
	useEffect(() => {
		if (fontFamily) {
			loadGoogleFont(fontFamily);
		}
	}, [fontFamily]);

	const closePopup = () => setShowTypography(false);

	return (
		<div className="gutnm-typography-wrapper">
			<div id="typography-control">
				{label ? label : __('Typography', 'gutenium')}
			</div>
			<Button
				className="gutnm-typography-edit"
				onClick={() => setShowTypography(true)}
			>
				<Dashicon icon="edit" />
				<Elevation active={1} focus={3} hover={3} value={3} />
			</Button>
			{showTypography && (
				<div className="gutnm-custom-popup-overlay" onClick={closePopup}>
					<div
						className="gutnm-custom-popup-content"
						onClick={(e) => e.stopPropagation()}
					>
						<Button className="gutnm-popup-close" icon="no-alt" onClick={closePopup} />
						<BaseControl>
							<SelectControl
								label={__('Font Family', 'gutenium')}
								value={fontFamily}
								options={fontOptions}
								onChange={(value) =>
									onChange({ ...typography, fontFamily: value })
								}
							/>
						</BaseControl>
					</div>
				</div>
			)}
		</div>
	);
};

export default MyTypographyControl;